export const valueProposalEs = {
  valueProposal: {
    title: "Propuesta de valor",
    description1: `Hacemos que la tecnología se convierta en hábito. Para que las empresas puedan enfocarse en su negocio, mientras nosotros nos ocupamos de que cada solución se implemente, se use y dé resultados.
    
    Así ayudamos a las organizaciones a innovar, escalar y sostener su liderazgo en un entorno en constante evolución.`,
    description2: `
    Co creamos con nuestros clientes productos de software de alta calidad, para abordar la transformación digital, siempre haciendo foco en la usabilidad y el diseño.`,
    button: "Más sobre de nosotros",
  },
};

export const valueProposalEn = {
  valueProposal: {
    title: "{{title}}",
    description1: "{{description1}}",
    description2: "{{description2}}",
    button: "{{button}}",
  },
};
